// extracted by mini-css-extract-plugin
module.exports = {"filled":"StarRating_filled__FYaTa","active":"StarRating_active__jtN7_","inactive":"StarRating_inactive__LmFgT"};